module.exports = __webpack_public_path__ + "img/55.1253af0b.png";